// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-E":"E_solar-60w-E__izbxf"};